import Vue from 'vue';
import App from '@/pages/root/App.vue';
import Vuetify from 'vuetify/lib';
import VueScrollactive from 'vue-scrollactive';
import VueConfetti from 'vue-confetti';
import { Datetime } from 'vue-datetime'
import VueVideoPlayer from 'vue-video-player'
import store from './store/index';
import router from './router';


import 'animate.css';
import '@/assets/css/mdb.min.css';
import 'vuetify/dist/vuetify.min.css';
import 'aos/dist/aos.css';
import 'vue-datetime/dist/vue-datetime.css'
import 'video.js/dist/video-js.css';


Vue.use(VueScrollactive);
Vue.use(VueConfetti);
Vue.use(Vuetify);
Vue.use(VueVideoPlayer);

Vue.component('datetime', Datetime);


Vue.config.productionTip = false;


export const eventBus = new Vue();
export default eventBus;

new Vue({
  router,
  store,
  vuetify: new Vuetify({}),
  render: h => h(App),
}).$mount('#app');
